<template>
  <div class="main" :class="{}">
    <Burger v-if="openBurger" @closeModal="openBurger = false"/>
    <img
      v-if="!isAuthRoute"
      src="@/assets/icons/burger.svg"
      class="burger"
      @click="openBurger = true"
    />
    <router-view/>
  </div>
  <teleport to="body">
    <GuestMbBanner v-if="!isAuthRoute" />
    <GuestOnbording v-if="!isAuthRoute" />
  </teleport>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Burger from "./components/burger.vue";
import GuestMbBanner from '@/components/guest/mobileBanner.vue';
import GuestOnbording from '@/components/guest/onbording.vue';

export default{
  data(){
    return{
      openBurger: false,
    }
  },
  computed: {
    isAuthRoute() {
      const authPaths = ['/', '/login', '/registration', '/registration-guest', '/reset'];
      return authPaths.includes(this.$route.path);
    },
  },
    components: {
    Burger,
    GuestMbBanner,
    GuestOnbording
  },
    mounted() {
        const THIRTY_MINUTES = 30 * 60 * 1000;

        setTimeout(() => {
            this.clearStorageExceptToken();
        }, THIRTY_MINUTES);
    },
  methods:{
    ...mapActions(["requestUser", "logoutUser"]),
      clearStorageExceptToken() {
          const token = localStorage.getItem('access_token');

          localStorage.setItem('search_find_model', '');
          localStorage.setItem('payload', '');
          sessionStorage.clear();

          console.log('Хранилище очищено (кроме токена)');
      },
    disableGuestActions() {
      // Запрет выделения текста
      document.body.style.userSelect = "none";

      // Запрет правой кнопки мыши
      document.addEventListener("contextmenu", this.preventContextMenu);
    },
    enableDefaultActions() {
      // Восстановить выделение текста
      document.body.style.userSelect = "";

      // Удалить запрет правой кнопки
      document.removeEventListener("contextmenu", this.preventContextMenu);
    },
    preventContextMenu(event) {
      event.preventDefault();
    }
  },
  async created() {
    const token = localStorage.getItem("access_token");
    if (token) {
      await this.requestUser();
    }
    const role = localStorage.getItem("user_role");
    if (role === "guest") {
      this.disableGuestActions();
    } else {
      this.enableDefaultActions();
    }
  },
}
</script>
<style lang="scss">
.main{
  position: relative;
}
.Loader {
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fcfafc;
}
.load-row {
  width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  img {
    object-fit: contain;
    width: 140px;
  }
}
.burger{
    position: absolute;
    top: 25px;
    left: 10px;
    width: 20px;
  @media(min-width: 768px){
    display: none;
  }
}
#app { 
width: 100vw; 
min-height: 100vh; 
display: flex; 
flex-direction: column; 
align-items: stretch; 
} 
 
html,body { 
  overflow-x: hidden; 
  margin: 0 ; 
  padding: 0 ; 
  font-size: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.5208))), 16px);
} 
p{
  font-size: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.5208))), 16px);
  margin: 0 ; 
  padding: 0 ; 
  font-size: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.5208))), 16px);
}
*{
  box-sizing: border-box;
 }
</style>
